/**
 * Maps Firebase Auth error codes to i18n keys (FIREBASE_AUTH.*).
 * Use with TranslateService.instant() for user-facing messages.
 * Unmapped codes return FIREBASE_AUTH.UNKNOWN_ERROR.
 */
const FIREBASE_CODE_TO_KEY: Record<string, string> = {
  'auth/email-already-in-use': 'FIREBASE_AUTH.EMAIL_ALREADY_IN_USE',
  'auth/weak-password': 'FIREBASE_AUTH.WEAK_PASSWORD',
  'auth/invalid-email': 'FIREBASE_AUTH.INVALID_EMAIL',
  'auth/too-many-requests': 'FIREBASE_AUTH.TOO_MANY_ATTEMPTS',
  'auth/operation-not-allowed': 'FIREBASE_AUTH.OPERATION_NOT_ALLOWED',
  'auth/user-disabled': 'FIREBASE_AUTH.USER_DISABLED',
  'auth/credential-already-in-use': 'FIREBASE_AUTH.EMAIL_ALREADY_IN_USE',

  'auth/invalid-credential': 'FIREBASE_AUTH.INVALID_CREDENTIAL',
  'auth/invalid-login-credentials': 'FIREBASE_AUTH.INVALID_CREDENTIAL',
  'auth/user-not-found': 'FIREBASE_AUTH.INVALID_CREDENTIAL',
  'auth/wrong-password': 'FIREBASE_AUTH.INVALID_CREDENTIAL',

  'auth/network-request-failed': 'FIREBASE_AUTH.NETWORK_ERROR',
  'auth/popup-closed-by-user': 'FIREBASE_AUTH.POPUP_CLOSED',
  'auth/cancelled-popup-request': 'FIREBASE_AUTH.POPUP_CLOSED',
  'auth/account-exists-with-different-credential':
    'FIREBASE_AUTH.ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL',
  'auth/requires-recent-login': 'FIREBASE_AUTH.REQUIRES_RECENT_LOGIN',
  'auth/expired-action-code': 'FIREBASE_AUTH.EXPIRED_ACTION_CODE',
  'auth/invalid-action-code': 'FIREBASE_AUTH.INVALID_ACTION_CODE',
  'auth/argument-error': 'FIREBASE_AUTH.INVALID_EMAIL',
  'auth/missing-email': 'FIREBASE_AUTH.INVALID_EMAIL',
  'auth/email-change-needs-verification': 'FIREBASE_AUTH.EMAIL_CHANGE_NEEDS_VERIFICATION',
  'auth/credential-too-old-login-again': 'FIREBASE_AUTH.REQUIRES_RECENT_LOGIN',
};

export function getFirebaseAuthMessageKey(error: unknown): string {
  const code = (error as { code?: string })?.code;
  if (code && FIREBASE_CODE_TO_KEY[code]) {
    return FIREBASE_CODE_TO_KEY[code];
  }
  return 'FIREBASE_AUTH.UNKNOWN_ERROR';
}
